<template>
  <LKPublicationsFormdataListModalContainer
    ref="modal"
    :title="title"
    @closed="$emit('closed')"
  >
    <div class="LKPublicationsFormdataListModal__wrapper">
      <LKMunMehExpertFormsList
        :mun-meh-id="data.id"
        @close="close"
      />
    </div>
  </LKPublicationsFormdataListModalContainer>
</template>

<script>
import LKPublicationsFormdataListModalContainer
  from '@/views/LKPublications/formdata/LKPublicationsFormdataListModalContainer.vue'
import LKMunMehExpertFormsList from '@/views/LKMunMeh/components/ExpertFormsListModal/LKMunMehExpertFormsList.vue'


export default {
  name: 'LKMunMehFormView',
  components: {
    LKMunMehExpertFormsList,
    LKPublicationsFormdataListModalContainer,
  },
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async open() {
      await this.$nextTick()
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
  },
}
</script>

<style lang="scss">
.LKPublicationsFormdataListModal {
  width: 100%;
  max-width: 1200px;
  height: 100%;
  margin-right: auto;
  margin-left: auto;

  &__wrapper {
    height: calc(100% - 52px);
  }
}
</style>
